import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Mascot from "../components/Mascot";
import SquishyButton from "../components/SquishyButton";
import { useGame } from "../context/GameContext";
import { speak } from "../lib/speech";
import { ShieldCheck } from "lucide-react";

export default function Landing() {
  const navigate = useNavigate();
  const { enableAudio } = useGame();
  useEffect(() => { const t = setTimeout(() => speak("Welkom bij SpeelSlim! Ouders kunnen hier inloggen."), 500); return () => clearTimeout(t); }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-sky-200 via-sky-100 to-emerald-50 flex flex-col items-center justify-center px-5 py-10 overflow-hidden">
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        {[0, 1, 2].map((i) => (
          <div key={i} className="absolute text-6xl opacity-70 animate-cloud-drift" style={{ top: `${8 + i * 22}%`, animationDelay: `${i * 12}s` }}>☁️</div>
        ))}
      </div>

      <motion.div initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} className="z-10 flex flex-col items-center">
        <h1 className="font-display text-5xl sm:text-6xl font-bold text-sky-600 drop-shadow-sm">SpeelSlim</h1>
        <p className="font-body font-bold text-slate-500 mb-2">Leren was nog nooit zo leuk!</p>
        <Mascot mood="idle" message="Welkom! Ouders loggen hier in." size={160} />
      </motion.div>

      <motion.div initial={{ y: 30, opacity: 0 }} animate={{ y: 0, opacity: 1 }} className="z-10 mt-8 flex w-full max-w-sm flex-col gap-4">
        <SquishyButton data-testid="landing-parent-login-btn" onClick={() => { enableAudio(); navigate("/ouders"); }}
          color="#4ADE80" edge="#16A34A" className="w-full text-2xl py-5 flex items-center justify-center gap-2">
          <ShieldCheck className="h-6 w-6" /> Ouder inloggen
        </SquishyButton>
        <p className="mt-1 text-center text-sm font-bold text-slate-400">
          Ouders loggen in en kiezen daarna wie er gaat spelen.
        </p>
      </motion.div>
    </div>
  );
}
